/*global Modernizr*/
/**
 * @overview Search page modal behaviour.
 *
 * @module search/modals
 */

import $ from 'qwery';
import MegaModal from '../../modules/MegaModal';
import { bindCuisineEvents } from './cuisines';
import { getInputByValue } from '../../helpers/domHelper';
import { dispatchEvent, isKeyEvent } from '../../helpers/eventHelper';
import { keys } from '../../constants';


function setup () {
    initRefinementEvents();
    initCuisineEvents();

    // Closes the modal if the screen size exceeds breakpoint threshold
    window.addEventListener('resize', () => {
        if (Modernizr.mq('(min-width: 800px)')) {
            dispatchEvent('MegaModal:close');
        }
    });
}

/**
 * Builds a new modal options object.
 *
 * @param {string} name - Name of the modal, used to identify the modal.
 * @param {function} afterShowFn - Function which fires after the modal has been shown.
 */
const createModalOptions = ({ name, afterShowFn } = {}) => ({
    modalType: 'fullscreen',
    className: `mm-modal-altBg,mm-modal--filters,mm-modal--filters--${name},controlList`,
    content: `[data-${name}-content]`,
    closeBtn: 'false',
    buttons: JSON.stringify([{
        text: 'OK',
        event: 'confirm',
        className: 'btn btn--primary btn--short'
    }]),
    afterShow: afterShowFn
});

/**
 * Checkbox input events.
 *
 * @param {string|Node} mainContext - context to use for the main page.
 * @param {string|Node} listItem - the list item which is the parent of the checkbox.
 */
function onCheckChanged (mainContext, listItem) {
    $('.control-input', listItem)[0].addEventListener('change', e => {
        const input = getInputByValue(e.target.value, mainContext);

        input.checked = e.target.checked;
        dispatchEvent('change', { context: input });
    });
}

function onTriggerClick (modalOptions) {
    if (Modernizr.mq('(max-width: 800px)')) {
        // Modal needs to be scoped here so that the filters can match up with the main page
        const modal = new MegaModal(modalOptions);
        modal.show();
    }
}

/**
 * Modal events
 *
 * @param {Node} modalTrigger
 * @param {object} modalOptions
 */
function bindModalEvents (modalTrigger, modalOptions) {
    modalTrigger.addEventListener('click', () => onTriggerClick(modalOptions));
    modalTrigger.addEventListener('keydown', event => {
        if (isKeyEvent(event, keys.ENTER)) {
            onTriggerClick(modalOptions);
        }
    });
}

/**
 * Modal show events.
 *
 * @param {string|Node} mainContext - context to use for the main page.
 * @param {string|Node} modalContext - Context to use for the modal.
 */
function onModalShow (mainContext, modalContext) {
    const mainCheckboxes = $('.control-input', mainContext);

    // Match up selected checkboxes in the modal
    mainCheckboxes.forEach(checkbox => {
        getInputByValue(checkbox.value, modalContext).checked = checkbox.checked;
    });

    $('.controlList-item', modalContext).forEach(listItem => onCheckChanged(mainContext, listItem));
}

/**
 * Bind modalrefinement events.
 *
 * @param {string|Node} context
 */
function initRefinementEvents () {
    const refinementModalTrigger = $('[data-refinement-modal-trigger]')[0];

    if (refinementModalTrigger) {
        const refineModalOptions = createModalOptions({
            name: 'refinement',
            afterShowFn: () => {
                onModalShow('[data-refinement-content]', '.mm-modal--filters--refinement');
            }
        });

        bindModalEvents(refinementModalTrigger, refineModalOptions);
    }
}

/**
 * Bind modal cuisine events.
 *
 * @param {string|Node} context
 */
function initCuisineEvents () {
    const cuisinesModalTrigger = $('[data-cuisine-modal-trigger]')[0];

    if (cuisinesModalTrigger) {
        const cuisinesModalOptions = createModalOptions({
            name: 'cuisines',
            afterShowFn: () => {
                onModalShow('[data-cuisine-filter]', '.mm-modal--filters--cuisines');

                bindCuisineEvents('.mm-modal--filters--cuisines', {
                    applyFilter: false,
                    shouldPositionCuisines: false
                });
            }
        });

        bindModalEvents(cuisinesModalTrigger, cuisinesModalOptions);
    }
}

setup();
